import { Card, CardContent, View } from "@/components/ui";
import { CaretRight } from "@/components/shared/icons";
import { type PackageData } from "@/types/package";
import { formatDateString } from "@/lib/helpers/date";
import { Typography } from "../typography";
import { useRoute } from "../router";
import { PackageStatusBadge } from "./package-status-badge";

export function PackageCard({ item }: { item: PackageData }) {
  const { push } = useRoute();

  const {
    packageDescription,
    startDate,
    endDate,
    fullAddress,
    postalCode,
    unitNumber,
    status,
  } = item;
  const handleClick = () => {
    push({ pageKey: "package", params: { id: item.id } });
  };

  return (
    <Card className="flex-1" shadow="sm" onClick={handleClick}>
      <CardContent className="px-3 py-3">
        <View className="mb-3 flex w-full flex-row items-start justify-between gap-3 border-b border-secondary-border">
          <View className="flex w-full flex-1 flex-row items-start justify-between pb-2 md:items-center">
            <Typography
              variant="label-sm"
              numberOfLines={1}
              className="max-w-[80%] md:max-w-none"
            >
              {packageDescription}
            </Typography>
            <PackageStatusBadge status={status} />
          </View>
        </View>
        <View className="flex flex-row items-center justify-between md:items-end">
          <View className="flex flex-col">
            <Typography
              variant="body-sm"
              color="foreground-intermediate"
              numberOfLines={1}
            >
              {`${formatDateString(startDate)} - ${endDate ? formatDateString(endDate) : "Not Set"}`}
            </Typography>
            <Typography
              variant="body-sm"
              color="foreground-intermediate"
              numberOfLines={1}
            >
              {fullAddress ? `${fullAddress}, ` : ""}
              {unitNumber ? `${unitNumber}, ` : ""}
              Singapore
              {postalCode ? ` ${postalCode}` : ""}
            </Typography>
          </View>
          <View className="flex w-full max-w-[110px] flex-row items-center justify-end gap-1">
            <Typography
              variant="caption-md"
              className="hidden text-button-cta2-hover md:flex"
            >
              View Detail
            </Typography>
            <CaretRight size={12} className="size-3 text-button-cta2-hover" />
          </View>
        </View>
      </CardContent>
    </Card>
  );
}
